module.exports = __webpack_public_path__ + "static/media/ivete_01.a598217b.mp4";